import { handleActions } from "redux-actions";

import removeById from "utils/removeById";
import updateById from "utils/updateById";

const incentiveReducer = handleActions(
  {
    TERMS_OF_SERVICE_GET_PENDING: () => ({
      termsOfService: null,
    }),

    TERMS_OF_SERVICE_GET_FULFILLED: (_, { payload: { termsOfService } }) => ({
      termsOfService,
    }),

    TERMS_OF_SERVICE_GET_ALL_FULFILLED: (_, { payload: { termsOfServices } }) => ({
      termsOfServices,
    }),

    TERMS_OF_SERVICE_CREATE_FULFILLED: ({ termsOfServices }, { payload: { termsOfService } }) => ({
      incentives: [termsOfService, ...termsOfServices],
    }),

    TERMS_OF_SERVICE_DELETE_FULFILLED: ({ termsOfServices }, { meta: { id } }) => ({
      termsOfServices: removeById(termsOfServices, id),
    }),

    TERMS_OF_SERVICE_SAVE_FULFILLED: ({ termsOfServices }, { payload: { termsOfService } }) => ({
      termsOfServices: updateById(termsOfServices, termsOfService),
    }),
  },
  {},
  { namespace: "_" }
);

export default incentiveReducer;
